// Generated from contracts/http/openapi.v1.json.
// Run npm run generate:api-client; do not edit by hand.

export const API_V1_BASE_PATH = "/api/v1";

export const apiV1Paths = Object.freeze({
  acknowledgeMindMapNotifications: () => "/api/v1/mindmaps/notifications/seen",
  activateBetaPro: () => "/api/v1/account/beta-pro-activation",
  createMindMap: () => "/api/v1/mindmaps",
  createNodeDiscussionMessage: (id, nodeId) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)) + "/nodes/" + encodeURIComponent(String(nodeId)) + "/discussion/messages",
  deleteMindMap: (id) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)),
  getAccountCapabilities: () => "/api/v1/account/capabilities",
  getAccountUpgradeContext: () => "/api/v1/account/upgrade-context",
  getMindMapById: (id) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)),
  getMindMapSharing: (id) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)) + "/sharing",
  getMindMapThumbnail: (id) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)) + "/thumbnail",
  getMyMindMap: () => "/api/v1/mindmaps/me",
  getNodeDiscussion: (id, nodeId) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)) + "/nodes/" + encodeURIComponent(String(nodeId)) + "/discussion",
  getPlatformDashboard: () => "/api/v1/platform/dashboard",
  listMindMaps: () => "/api/v1/mindmaps",
  listNodeDiscussions: (id) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)) + "/node-discussions",
  markNodeDiscussionRead: (id, nodeId) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)) + "/nodes/" + encodeURIComponent(String(nodeId)) + "/discussion/read",
  removeMindMapMember: (id, userId) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)) + "/members/" + encodeURIComponent(String(userId)),
  removeSavedMindMapLink: (id) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)) + "/saved-link",
  saveMindMapById: (id) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)),
  saveMindMapLink: (id) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)) + "/saved-link",
  saveMyMindMap: () => "/api/v1/mindmaps/me",
  updateMindMapArchive: (id) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)) + "/archive",
  updateMindMapDescription: (id) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)) + "/description",
  updateMindMapLinkAccess: (id) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)) + "/link-access",
  updateMindMapTitle: (id) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)) + "/title",
  updatePlatformSettings: () => "/api/v1/platform/settings",
  uploadMindMapThumbnail: (id) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)) + "/thumbnail",
  upsertMindMapMember: (id) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)) + "/members",
});
